import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import DotMailerTrackerBaseComponent from './js/dot-mailer-tracker-base.component';

ComponentsFactory.getInstance().define('dot-mailer-tracker', DotMailerTrackerBaseComponent);
